import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param dcId
 * @param poId
 */
class DCServices {
    /**
     *
     * @param {*} payload
     * @return
     */
    createDC = async (payload) => {
      const dc = await Helpers.post({
        url: Constants.DC,
        data: payload,
      });
      return dc;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateDC = async (payload) => {
       const dc = await Helpers.put({
         url: Constants.DC,
         data: payload,
       });
       return dc;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     updateDCStatus = async (payload) => {
       const po = await Helpers.put({
         url: Constants.DC_STATUS,
         data: payload,
       });
       return po;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
        updateDCWorkflowStep = async (payload) => {
          const dc = await Helpers.post({
            url: Constants.DC_WORKFLOW,
            data: payload,
          });
          return dc;
        }

        /**
         * @param challanId
         * @param {*} payload
         * @return
         */
      deleteDC = async (challanId) => {
        let url = `${Constants.DC}?`;
        if (challanId) url += `challan_id=${challanId}&`;
        const dc = await Helpers.delete({ url });
        return dc;
      }

      /**
       * @param {*} orgId
       * @param {*} entityType
       * @param {*} dcId
       * @param {*} page
       * @param tenantId
       * @param customerId
       * @param tenantSellerId
       * @param status
       * @param searchKeyword
       * @param stockTransferId
       * @param challanId
       * @param invoiceId
       * @param invoiceLineId
       * @param {*} limit
       * @return
       */
    getDC = async (tenantId, stockTransferId, challanId, limit, page, searchKeyword, invoiceId, invoiceLineId, department, secondaryStatus, is_list) => {
      let url = `${Constants.DC}?`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (stockTransferId) url += `stock_transfer_id=${stockTransferId}&`;
      if (challanId) url += `challan_id=${challanId}&`;
      if (invoiceId) url += `invoice_id=${invoiceId}&`;
      if (invoiceLineId) url += `invoice_line_id=${invoiceLineId}&`;
      // if (status) url += `status=${status}&`;
      if (limit) url += `limit=${limit}&`;
      if (page) url += `page=${page}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (department) url += `department_id=${department}&`;
      if (secondaryStatus) url += `secondary_status=${secondaryStatus}&`;
      if (is_list) url += `is_list=true&`;

      const dc = await Helpers.get({ url });

      return dc;
    }

    updateDCWorkflowStep = async (payload) => {
      const updateDCWorkflowStep = await Helpers.post({
        url: `${Constants.DC}/workflow`,
        data: payload,
      });
      return updateDCWorkflowStep;
    }

    updateDeliveryChallanStatus = async (payload) => {
      const updateDeliveryChallanStatus = await Helpers.put({
        url: `${Constants.DC}/status`,
        data: payload,
      });
      return updateDeliveryChallanStatus;
    }
    
    quickUpdateDeliveryChallan = async (payload) => {
      const quickUpdateDeliveryChallan = await Helpers.put({
        url: Constants.DC_QUICK_UPDATE,
        data: payload,
      });
      return quickUpdateDeliveryChallan;
    }
}
export default new DCServices();
